<app-header></app-header>
@if (loadingLazyModule) {
  <div class="site-loader-wrapper grey-bg-loader">
    <div class="loader"></div>
  </div>
}
<router-outlet></router-outlet>
<!--toaster-container></toaster-container-->
<app-footer></app-footer>

